import React, { useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import "./MenuItem.scss"
import _ from 'lodash';
import { getCurrencyFormat, LOCAL_STORAGE_ITEMS_NAMES } from '../../../../../utilities/helper';
const MenuItem = ({ headerText, items }) => {
    const { currency
    } = useSelector((state) => state.resturantData);
    const currencyFormat = getCurrencyFormat(currency);


    const selectedOrderType = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA) && JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA)).selectedOrderType
    const getThePrice = (price) => {
        let priceValue;

        switch (selectedOrderType) {
            case "delivery":
                priceValue = price?.DeliveryPrice;
                break;
            case "table":
                priceValue = price?.TablePrice;
                break;
            default:
                priceValue = price?.PickupPrice;
                break;
        }
        return currencyFormat(priceValue / 100);
    };


    const renderLayout = (menuItem) => {
        return (
            <div className="column-itemregal">
                <div className="column-itemregal-cont">
                    <div className="column-itemregal-cont-inner">
                        <div className="name">{menuItem?.Title?.en?.toCapitalFirst().replace(/\.+$/, '')}
                        </div>
                    </div>
                    <div className="price">
                        {getThePrice(menuItem?.PriceInfo?.Price)}
                    </div>
                </div>
            </div>
        )
    }
    return (
        <div className="MenuItem-Suvai">
            <div className="MenuItem-Suvai-title" >{headerText?.toLowerCase() || ""}
            </div>
            <div className="MenuItem-Suvai-column">
                {items.map(((menuItem, key) => {
                    return (
                        <div className="MenuItem-Suvai-column-styles" key={key}>
                            {renderLayout(menuItem)}
                        </div>
                    )
                }))}
            </div>
        </div >
    )
}
export default MenuItem